"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _FormattedMessage2, _FormattedMessage3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PasswordLabelTranslation = _ref => {
  let {
    label
  } = _ref;
  if (label === "STRONG") {
    return _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "account.password_validation.strength_label.strong"
    }));
  }
  if (label === "MEDIUM") {
    return _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "account.password_validation.strength_label.medium"
    }));
  }
  return _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
    id: "account.password_validation.strength_label.weak"
  }));
};
var _default = exports.default = PasswordLabelTranslation;